var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const React = require('react');
const Icon = require('@infotech/uikit-icon').default;

function Svg(props) {
  const svgProps = Object.assign({}, props);
  const title = props.title;
  delete props.title;

  /* <svg {...svgProps} ><title>{title}<title>...</svg> */
  return React.createElement(
    'svg',
    _extends({ width: '16', height: '16', viewBox: '0 0 16 16', focusable: 'false' }, svgProps, { 'aria-labelledby': 'title' }),
    React.createElement(
      'title',
      { id: 'title' },
      title
    ),
    React.createElement('path', { d: 'M5 12.585l8.588-8.588-1.59-1.587L3.411 11 5 12.585zm-3.672-2.33L11.29.29a1 1 0 011.414-.001l3.006 3a1 1 0 01.001 1.415l-9.952 9.95a.997.997 0 01-.561.324l-3.954.99A1 1 0 01.03 14.757l.994-3.982a.998.998 0 01.304-.518z', role: 'presentation' })
  );
}

module.exports = function edit(props) {
  return React.createElement(Icon, _extends({ glyph: Svg }, props));
};